import VueCqrs from '@cqrs/vue-component-cqrs';
import * as q from '@ProjectUsers/Domain/queries';
import { Component } from 'vue-facing-decorator';

@Component
export default class ProjectUsersQueries extends VueCqrs
{
	runProjectUsersByLocalIdsQueryV1(workspaceId: number, projectId: number, localIds: string[])
	{
		const query = q.buildProjectUsersByLocalIdsQueryV1(workspaceId, projectId, localIds);
		this.$query(query);
	}

	runProjectUsersByIdsQueryV1(workspaceId: number, projectId: number, projectUsersIds: number[])
	{
		const query = q.buildProjectUsersByIdsQueryV1(workspaceId, projectId, projectUsersIds);
		this.$query(query);
	}

	runPeoplePageQueryV1(workspaceId: number, projectId: number)
	{
		const query = q.buildPeoplePageQueryV1(workspaceId, projectId);
		this.$query(query);
	}

	runProjectUserDependenciesQueryV1(workspaceId: number, projectId: number, projectUserId: number)
	{
		const query = q.buildProjectUserDependenciesQueryV1(workspaceId, projectId, projectUserId);
		this.$query(query);
	}
}